module.exports = __webpack_public_path__ + "img/icon.5b1d6bf3.png";